export default __webpack_public_path__ + "static/media/staff.7c1047cc.svg";